import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { createErrorHub } from "@/lib/errorHub";

// Monitoreo de errores (Phrourós). Sin la key en el entorno, no hace nada.
if (process.env.REACT_APP_ERROR_HUB_API_KEY) {
  createErrorHub({
    apiKey: process.env.REACT_APP_ERROR_HUB_API_KEY,
    origin:
      process.env.REACT_APP_ERROR_HUB_ORIGIN ||
      "https://panel3r2ores.atiktechmx.com",
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
